<template>
  <div>
    <NavBar :user="user"></NavBar>

    <div id="trackers-page" class="map-page" v-if="user.inStaffGroup">
      <div class="panel-container">
        <div class="panel panel-default">
          <div class="panel-heading">
            <div class="filters">
              <form>
                <div class="row">
                  <div class="col-12">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="material-icons">person</i>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="tracker_name"
                        data-test="name-filter"
                        placeholder="Name"
                        v-model="trackerFilterName"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="filter-group-row">
                    <div class="filter-item">
                      <input
                        type="checkbox"
                        id="online-checkbox"
                        data-test="online-filter-button"
                        value="online"
                        v-model="onlineCheckbox"
                      />
                      <label
                        for="online-checkbox"
                        class="unselectable badge badge-outline badge-success"
                      >
                        online
                      </label>
                    </div>
                    <div class="filter-item">
                      <input
                        type="checkbox"
                        id="show-hidden-checkbox"
                        data-test="show-hidden-filter-button"
                        v-model="showHiddenCheckbox"
                      />
                      <label
                        for="show-hidden-checkbox"
                        class="unselectable badge badge-outline badge-grey"
                      >
                        show hidden
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="panel-body">
            <div
              :class="'map-item' + (allItemsAreSelected ? ' selected' : '')"
              @click="selectAll"
            >
              <div class="list-icon">
                <i class="material-icons">near_me</i>
              </div>
              <div class="list-content">
                <div class="transfer-info">
                  <h2 class="list-group-item-heading">
                    <translate>All trackers</translate>
                  </h2>
                  <div class="list-place">
                    <translate>Show all trackers from last 7 days</translate>
                  </div>
                </div>
              </div>
            </div>
            <TrackerItem
              v-for="item in nonFilteredItems"
              data-test="tracker-item"
              :key="item.name"
              :item="item"
              :selected="isSelected(item)"
              @selected="select"
            />
          </div>
        </div>
        <div class="last-refresh-time">
          <translate>Last auto-refresh:</translate>
          {{ lastRefreshTimeDelta }}
        </div>
      </div>
      <Map></Map>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import $ from 'jquery'
import baseController from '../../controllers/base'
import FullScreenMap from '../../controllers/full-screen-map'
import NavBar from '../common/NavBar'
import Map from '../common/Map'
import TrackerItem from './TrackerItem'
import { findAllTrackers, getLocations } from './actions'

export default {
  extends: baseController,
  components: {
    NavBar,
    Map,
    TrackerItem
  },
  props: ['user'],
  data() {
    return {
      selectedItemId: null,
      trackerFilterName: '',
      lastRefresh: null,
      lastRefreshTimeDelta: moment().fromNow(),
      trackerFilterNameDelta: moment().fromNow(),
      onlineCheckbox: false,
      showHiddenCheckbox: false,
      items: null
    }
  },
  computed: {
    trackerFilters() {
      return {
        name: this.trackerFilterName.toLowerCase().trim(),
        online: this.onlineCheckbox,
        showHidden: this.showHiddenCheckbox
      }
    },
    firstSelectedTracker() {
      return this.getVisibleTrackers().find(tracker => tracker.selected)
    },
    nonFilteredItems() {
      return _.filter(this.items, this.itemIsNotFiltered)
    },
    allItemsAreSelected() {
      return this.selectedItemId == null
    }
  },
  mounted() {
    this.map = new FullScreenMap($('#leaflet', this.el))
    this.periodicAutoRefresh()
    setInterval(this.updateLastRefreshTimeDelta, 1000 * 20)
  },
  watch: {
    trackerFilterName() {
      this.loadTrackers()
    },
    onlineCheckbox() {
      this.loadTrackers()
    },
    showHiddenCheckbox() {
      this.loadTrackers()
    }
  },
  methods: {
    getVisibleTrackers() {
      return _.filter(this.items, item => this.itemIsNotFiltered(item))
    },
    async select(item) {
      item.locations = await getLocations(item.id)
      const itemHasChanged = this.selectedItemId !== item.id
      this.map.render(item.layers(), { fitBounds: itemHasChanged })
      this.selectedItemId = item.id
    },
    async selectAll() {
      this.selectedItemId = null
      showAllLastLocations(this.map, this.getVisibleTrackers())
    },
    periodicAutoRefresh() {
      setTimeout(() => this.periodicAutoRefresh(), 1000 * 60 * 5) // minutes
      return this.loadTrackers()
    },
    updateLastRefreshTimeDelta() {
      return (this.lastRefreshTimeDelta = this.lastRefresh.fromNow())
    },
    refreshSelection() {
      if (this.firstSelectedTracker) {
        this.select(this.firstSelectedTracker)
      } else {
        this.selectAll()
      }
    },
    async loadTrackers() {
      this.lastRefresh = moment()
      this.items = await findAllTrackers()
      this.refreshSelection()
    },
    itemIsNotFiltered(item) {
      return (
        normalize(item.name).includes(this.trackerFilters.name) &&
        ((item.isOnline && this.trackerFilters.online) || !this.trackerFilters.online) &&
        (this.trackerFilters.showHidden || !item.isHidden)
      )
    },
    isSelected(item) {
      return this.selectedItemId === item.id
    }
  }
}

function normalize(name) {
  return name.toLowerCase().trim()
}

function showAllLastLocations(map, visibleTrackers) {
  map.render(_.flatten(visibleTrackers.map(tracker => tracker.latestLocationLayer)), {
    fitBounds: true
  })
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>
